//dependencies
import dropdown from "angular-ui-bootstrap/src/dropdown";
import collapse from "angular-ui-bootstrap/src/collapse";
import tabs from "angular-ui-bootstrap/src/tabs";
import ngSanitize from "angular-sanitize";

//services

//components
import usergroupList from "emun.auth/usergroups/usergroup-list";
import usergroupEdit from "emun.auth/usergroups/usergroup-edit";

export const dependencies = [dropdown, collapse, tabs, ngSanitize];

export const modules = {
  // modals,
};
//states
import states from "emun.auth/usergroups/usergroups.states";

export const services = {};

export const components = {
  usergroupList,
  usergroupEdit
};

export const directives = {};

export default {
  modules,
  services,
  dependencies,
  components,
  directives,
  states
};
